const autoNgTemplateLoaderTemplate1 = require('./docker-sidebar.html');

angular.module('shbdeployer.docker').component('dockerSidebar', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    isSidebarOpen: '<',

    endpointApiVersion: '<',
    swarmManagement: '<',
    standaloneManagement: '<',
    adminAccess: '<',
    offlineMode: '<',
    currentRouteName: '<',
    endpointId: '<',
    showStacks: '<',
  },
});
